// @flow
import type {State} from 'src/reducers';


export const selectCsrfToken = (state: State): ?string => state.csrf?.token;
